export default (carousel, parentClass, autoplayDelay = 3000, reverseDirection = false, stop = false) => {
  const otherCasesSlider = document.querySelector('.other-cases-swiper');

  if (!carousel || !carousel.autoplay || carousel.autoplay.running || otherCasesSlider) {
    return;
  }

  let current = carousel.wrapperEl;

  while (current && !current.classList.contains(parentClass)) {
    current = current.parentNode;
  }

  if (!current) {
    return;
  }

  const bounding = current.getBoundingClientRect();
  const screenHeight = (window.innerHeight / 3) * 2;

  if (bounding.top < screenHeight) {
    carousel.autoplay.start();
    carousel.params.autoplay.delay = autoplayDelay;
    carousel.params.autoplay.reverseDirection = reverseDirection;
    carousel.params.autoplay.disableOnInteraction = false;
  }

  if (stop) carousel.autoplay.stop();
};
